import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { isDevMode } from '@angular/core';

declare var require: any;
const { version: appVersion } = require('../../../../package.json');

export function HttpLoaderFactory(http: HttpClient) {
  return new ManifestTranslateLoader(http);
}

export class ManifestTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    if (isDevMode()) {
      return this.http.get(`/assets/i18n/${lang}.json`);
    }
    return this.http.get<Record<string, string>>(`/assets/i18n/${lang}.${appVersion.replaceAll('.', '-')}.json`);
  }
}
